import { useEffect } from 'react'
import { Construction } from 'lucide-react'

export function ComingSoon() {
  useEffect(() => {
    document.title = 'Coming Soon | Fast Aid Hospital'
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 px-4">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <Construction className="w-16 h-16 text-teal-600" />
        </div>
        <h1 className="text-4xl font-bold text-slate-800 mb-4">
          Coming Soon
        </h1>
        <p className="text-lg text-slate-600 mb-2">
          Our website is under development.
        </p>
        <p className="text-slate-500">
          We are working hard to bring you something amazing. Stay tuned!
        </p>
        <div className="mt-8 text-sm text-slate-400">
          &copy; {new Date().getFullYear()} Fast Aid Hospital - Chauddagram
        </div>
      </div>
    </div>
  )
}
